import { Button, Card, Checkbox, FormControlLabel, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
import DateHora from '../../../../utils/dateHora'
import ButtonLeft from "../../../../utils/buttonLeft";
import FazerObservacoes from "../../../components/fazerObservacoes.";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
// import { useParams } from 'react-router-dom';
import api from '../../../../services/api';
import StatusSolicitacoes from '../../../../utils/status/statusSolicitacoes';
import InfoFieldGroup from '../../../../utils/InfoField/InfoFieldGroup';

export default function FichaSolicitacaoDesalfandegamento({ solicitacaoImportacao, setRefresh, habiliteThis, setHabiliteThis, admin = false }) {
    const user = useSelector(state => state.account.user);
    // const { id } = useParams()
    const dispatch = useDispatch()
    const [action, setAction] = useState('approve')
    const [obs, setObs] = useState('Confirmo que o processo está em conformidade.')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    const [confirmProcesso, setConfirmProcesso] = useState(false)

    const handleApprove = (assunto) => {
        setLoad(true)
        api.patch('/declaracao-desalfandegamento/approve', {
            declaracaoDesalfandegamentoId: solicitacaoImportacao.declaracao._id,
            userId: user?._id,
        }).then(response => {
            // console.log(response);
            HandleCreateobservacao(assunto);
            setRefresh(response.data);
            dispatch({
                type: 'alert',
                payload: { alert: 'Solicitação de desalfandegamento aprovada com sucesso.!' },
            });
        }).catch(error => {
            // console.log(error);
            setMessageError(error.response.data.message)
        }).finally(() => setLoad(false))
    }

    async function HandleCreateobservacao(assunto) {
        setLoad(true)
        setMessageError('')
        setMessageSuccess('')

        await api.post('/observacao/create', {
            assunto: assunto,
            descricao: obs ?? 'Confirmo que o processo está em conformidade.',
            userId: user._id,
            estabelecimentoId: solicitacaoImportacao.importador._id
        }).then(res => {
            setLoad(false)
            setMessageSuccess(res.data.msg)

        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
            setLoad(false)
        })
    }

    return (
        <Card style={{ padding: 20, position: 'relative' }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs
                menu={false}
                configArea={''}
                title={'SOLICITAÇÃO DE DESALFANDEGAMENTO'}
            />

            {(solicitacaoImportacao?.declaracao.status === 'Aprovado' && solicitacaoImportacao?.declaracao.dataAprovacao) &&
                <img src="/img/icones/licenciamentoicon.svg" alt="autor.." width={30} style={{ position: 'absolute', right: 20 }} />
            }
            <InfoFieldGroup
                isEdit={false}
                load={false}
                fields={
                    [
                        { label: 'Estado', value: <StatusSolicitacoes status={solicitacaoImportacao?.declaracao?.status} />, editable: false, },
                        { label: 'Declaração Nº', value: solicitacaoImportacao?.declaracao.numeroDeclaracao, editable: false, },
                        { label: 'Nº de Porte', value: solicitacaoImportacao?.declaracao.numeroPorte, editable: false, },
                        { label: 'Ponto de Entrada', value: solicitacaoImportacao?.declaracao.pontoEntrada, editable: false, },
                        { label: 'Destino', value: solicitacaoImportacao?.declaracao.destino, editable: false, },
                        // { label: 'Factura de Emolumento', value: solicitacaoImportacao?.declaracao?.numFatura, editable: false, },
                        { label: 'Data de Solicitação', value: <DateHora date={solicitacaoImportacao.declaracao.createdAt} />, editable: false, },

                    ]
                } />

            {(solicitacaoImportacao?.declaracao.status !== 'Aprovado' && !solicitacaoImportacao?.declaracao.dataAprovacao && habiliteThis && admin) &&
                <>
                    <FazerObservacoes setObs={setObs} obs={obs} titulo={action === 'approve' ? '(caso seja necessário fazer alguma observação)' : '(Descreve os motivos desta reprovação para o utente)'} />
                    <Typography my={2}>
                        <b> O processo está em conformidade? </b>
                        <FormControlLabel value={!confirmProcesso} name='tipoAutorizacao' control={<Checkbox checked={confirmProcesso} />} onChange={() => setConfirmProcesso(!confirmProcesso)} />
                    </Typography>
                    <ButtonLeft
                        title={'Aprovar'}
                        funcao={() => handleApprove('Desalfandegamento')}
                        disabled={!confirmProcesso}
                        load={load}
                    >
                        <Button color="error" onClick={() => setHabiliteThis(false)}>Reprovar</Button>
                    </ButtonLeft>
                </>
            }
        </Card>
    )
}
